export const SET_CONTA = 'SET_CONTA';
export const SET_CONTA_LOADING = 'SET_CONTA_LOADING';
